require(['app/config.js', 'app/shared/nav/navController.js', 'app/shared/selections/selectionsDirective.js', 
  'app/shared/barchart/horizontalBarChartDirective.js', 'app/shared/barchart/verticalBarChartDirective.js',
  'app/shared/filters/filterDirective.js', 'app/shared/filters/calendarFilterDirective.js', 'app/shared/tables/driverTableDirective.js',
  'app/components/dashboard/dashboardController.js', 'app/components/drivers/driversController.js', 'app/components/constructors/constructorsController.js',
  'app/components/race/raceController.js', 'app/components/race/rankChartDirective.js'],

  function(config, navController, selectionsDirective, horizontalBarChartDirective, verticalBarChartDirective, 
    filterDirective, calendarFilterDirective, driverTableDirective, dashboardController, driversController, constructorsController, 
    raceController, rankChartDirective){
  	var app = angular.module('f1App', ['ngRoute','uiSwitch', 'ui.bootstrap', 'ui.select', 'ngSanitize', 'angular-click-outside']);
    app.config(config);

    //shared
    app.controller('navController', navController);
    app.directive('selections', selectionsDirective);
    app.directive('horizontalBarChart', horizontalBarChartDirective);
    app.directive('verticalBarChart', verticalBarChartDirective);
    app.directive('filter', filterDirective);
    app.directive('calendarFilter', calendarFilterDirective);
    app.directive('driverTable', driverTableDirective);

    //dashboard
    app.controller('dashboardController', dashboardController);

    //drivers
    app.controller('driversController', driversController);

    //constructors
    app.controller('constructorsController', constructorsController);

    //races
    app.controller('raceController', raceController);
    app.directive('rankChart', rankChartDirective);
});
define("app/app.js", function(){});

